class SwatchesMultiColumnGridItem extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
    this.checkIfInSwatchBuilder()
  }

  setupListeners () {
    super.setupListeners()

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.SWATCH_BUILDER.PRODUCT_SELECTED,
      this.onSwatchBuilderChanged.bind(this),
    )

    document.addEventListener('swatch-builder:updated', () => {
      this.checkIfInSwatchBuilder()
    })
  }

  disconnectedCallback () {
    super.disconnectedCallback()

    window.BAO.eventBus.removeEventListener(
      window.BAO.EVENTS.SWATCH_BUILDER.PRODUCT_SELECTED,
      this.onSwatchBuilderChanged.bind(this),
    )
  }

  onSwatchBuilderChanged (event) {
    setTimeout(() => {
      this.checkIfInSwatchBuilder()
    }, 150)
  }

  checkIfInSwatchBuilder () {
    const productHandle = this.dataset.productHandle
    const quickAddExternalEl =
      this.externalEls && this.externalEls.quickAddSwatchMultiGrid

    if (!productHandle || !quickAddExternalEl || !quickAddExternalEl.element) {
      return
    }

    const quickAddButton = quickAddExternalEl.element

    if (!quickAddButton) return

    const stored = sessionStorage.getItem('BAO-swatch-builder-selections')

    if (stored) {
      try {
        const mapAsArray = JSON.parse(stored)
        const selectedSwatches = new Map(mapAsArray)
        const isSelected = selectedSwatches.has(productHandle)

        if (isSelected) {
          quickAddButton.classList.add(
            'sec-MultiColumnGrid_QuickAddButton-active',
          )
        } else {
          quickAddButton.classList.remove(
            'sec-MultiColumnGrid_QuickAddButton-active',
          )
        }
      } catch (error) {
        console.error('Error checking swatch builder selection:', error)
      }
    } else {
      quickAddButton.classList.remove(
        'sec-MultiColumnGrid_QuickAddButton-active',
      )
    }
  }
}

if (!customElements.get('swatches-multi-column-grid-item')) {
  customElements.define(
    'swatches-multi-column-grid-item',
    SwatchesMultiColumnGridItem,
  )
}
